import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="3f2wxvnuzz3xr">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] sm:text-sm ${dark ? 'text-brand-light' : 'text-brand'}`} data-id="element-45" data-mp="3k186xwdgxaex">{eyebrow}</p>}
      <h2 className={`mt-3 font-serif text-[30px] font-bold leading-[1.15] sm:text-4xl md:text-5xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-46" data-mp="bmpulighv8pi">{title}</h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-brand-light' : 'text-muted'}`} data-id="element-47" data-mp="1tsk9zlnoq1z">{subtitle}</p>}
    </div>;
}